import * as _ from "lodash";
import { EmailDeliveryService } from "../email-delivery/email-delivery.service";
import {
    EmailDeliveryEvent,
    EmailDeliveryStatus,
    EmailDeliveryStatusDetail
} from "../email-delivery/email-delivery.type";
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { LoggerService } from "@teammood/shared/util/logger";
import { catchError, EMPTY, filter, mergeMap, Subject, takeUntil, tap } from "rxjs";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "email-delivery-status",
    templateUrl: "./email-delivery-status.component.html",
    providers: [
        EmailDeliveryService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EmailDeliveryStatusComponent implements OnInit, OnDestroy {

    status: Array<EmailDeliveryStatusDetail>;
    details: EmailDeliveryStatus;

    private _destroy$ = new Subject<void>();

    constructor(
        private logger: LoggerService,
        private route: ActivatedRoute,
        private emailDeliveryService: EmailDeliveryService
        ) {}

    ngOnInit() {
        this.loadStatus();
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    loadStatus() {

        this.route.params
            .pipe(
                filter(params => !!params['id']),
                mergeMap(params => {
                    return this.emailDeliveryService.status(params['id']);
                }),
                tap(status => {
                    const providers: string[] = _.uniq(status.events.map(evt => {
                        return evt.id
                    }));

                    const findEvent = function (provider: string, event: string) : EmailDeliveryEvent | undefined {
                        return _.find(status.events, (evt) => {
                            return evt.status === event && evt.id === provider;
                        });
                    }

                    this.status = providers.map((provider: string) => {
                        return {
                            id: provider,
                            sent: findEvent(provider, 'sent'),
                            delivered: findEvent(provider, 'delivered'),
                            opened: findEvent(provider, 'opened'),
                            clicked: findEvent(provider, 'clicked')
                        }
                    });

                    this.details = status;
                }),
                catchError((error: string) => {
                    this.logger.error(error);
                    return EMPTY;
                }),
                takeUntil(this._destroy$)
            ).subscribe();

    }
}